@use "../../styles/breakpoint.module.scss" as *;

.root {
    overflow-x: hidden;

    .grid {
        gap: var(--spacer-104) var(--labui-grid-gap);
    }
}

.match {
    composes: root;
    composes: match from "../../styles/theming.module.css";
}

.contrast {
    composes: root;
    composes: contrast from "../../styles/theming.module.css";
}

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.fullWidth {
    grid-column: 1 / -1;
    text-align: center;
}

.introContent {
    composes: fullWidth;
    transform-origin: top center;
}

.headerSubtitle {
    & :is(p, li) {
        font: var(--font-h-20);
    }
}

.mainContent {
    composes: grid from "../../styles/composable/layout.module.css";
    grid-column: 1 / -1;
}

.valueProps {
    --columns: 3;
    --gutters: calc(var(--columns) - 1);
    --gutter-width: var(--spacer-80);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--columns));

    grid-column: 2 / span 10;
    display: flex;
    gap: var(--spacer-80);

    @media ($below-mobile) {
        grid-column: 1 / -1;
        padding-inline: var(--spacer-80);
        flex-direction: column;
    }

    > * {
        flex: 1 0 0%;
        width: var(--width);

        @media ($below-mobile) {
            width: 100%;
        }
    }
}

.valueProp {
    position: relative;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: var(--xcient-gradient-linear);
    }
}

.title {
    font: var(--font-h-64);
    font-size: max(6.5vw, 48px);
    margin-block: var(--spacer-24) var(--spacer-8);
}

.subtitle {
    font: var(--font-h-20);
    font-weight: 400;
}

.logo {
    fill: currentColor;
    width: 50%;
    margin-bottom: var(--spacer-24);

    @media ($above-mobile) {
        max-width: 600px;
        min-width: 300px;
    }

    @media ($below-mobile) {
        width: 75%;
    }
}

.cta {
    composes: fullWidth;
    margin-top: var(--spacer-104);
}
